/** All prologue dialogue as data; registered into the shared DIALOGUES registry. */
import { registerDialogues } from '@/dialogue';
import { PROLOGUE_DIALOGUES } from './data';

export { PROLOGUE_DIALOGUES, findPrologueDialogue } from './data';

let registered = false;
export function registerPrologueDialogues(): void {
  if (registered) return;
  registered = true;
  registerDialogues(PROLOGUE_DIALOGUES);
}
